export default "__VITE_ASSET__BKwsnLkV__"